import findIndex from 'lodash/findIndex';

import type { ReactiveVars } from '../../../..';
import type { AbstractDrawerUnionInterface as AdminAbstractDrawerUnionInterface } from '../../../../../schema/admin';
import type { AbstractDrawer, AbstractDrawerUnionInterface as UserAbstractDrawerUnionInterface } from '../../../../../schema/user';
import type { DeepRequired } from '../../../../../services/object';

export default function createUpdateDrawer(drawersVar: ReactiveVars['drawersVar']) {
  return <Drawer extends UserAbstractDrawerUnionInterface | AdminAbstractDrawerUnionInterface>(
    drawerToUpdate: Drawer,
    newValues: DeepRequired<Omit<Drawer, keyof AbstractDrawer | '__typename'>>,
  ): void => {
    const drawers = drawersVar();
    const updateIndex = findIndex(drawers, { id: drawerToUpdate.id });

    if (updateIndex !== -1) {
      drawersVar([
        ...drawers.slice(0, updateIndex),
        { ...drawers[updateIndex], ...newValues },
        ...drawers.slice(updateIndex + 1),
      ]);
    }
  };
}
